import EmptyView from './EmptyView';

export default EmptyView;
